import { render } from "./LpSearchDropdown.vue?vue&type=template&id=15bc36ea&ts=true"
import script from "./LpSearchDropdown.vue?vue&type=script&lang=ts"
export * from "./LpSearchDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__